import React, { FC } from 'react';

import { DocumentsCommon } from '../DocumentsCommon';
import { useGeneralDocumentsProps } from './utils';


export const GeneralDocuments: FC = () => {
    const componentProps = useGeneralDocumentsProps();

    return (
        <DocumentsCommon {...componentProps} defaultOpen />
    );
};
